import { render, staticRenderFns } from "./UpgradeTermsAndConditionsForSVRCustomers.vue?vue&type=template&id=2dc1b16e&scoped=true&"
import script from "./UpgradeTermsAndConditionsForSVRCustomers.vue?vue&type=script&lang=js&"
export * from "./UpgradeTermsAndConditionsForSVRCustomers.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeTermsAndConditionsForSVRCustomers.vue?vue&type=style&index=0&id=2dc1b16e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc1b16e",
  null
  
)

export default component.exports